const CoachCard = ({ name, role, image }) => (
  <article className="relative rounded-2xl min-h-[300px] overflow-hidden shadow-course-card">
    {image ? (
      <img
        src={image}
        alt={name}
        className="absolute inset-0 w-full min-h-[350px] object-cover"
      />
    ) : (
      <div className="absolute inset-0 bg-primary" />
    )}
    <div
      className="absolute inset-0"
      style={{
        background:
          "linear-gradient(180deg, rgba(5,7,148,0) 40%, rgba(5,7,148,0.88) 100%)",
      }}
    />
    <div className="relative h-full flex flex-col justify-end p-5">
      <h3 className="text-white text-xl font-bold mb-1">{name}</h3>
      <p className="text-[#F0F5FF] text-[14px] m-0">{role}</p>
    </div>
  </article>
);

const CourseAssociateCoachesSection = ({ selectedCourseData }) => {
  const courseCoaches = selectedCourseData?.courseCoaches || [];
  const associates = courseCoaches.slice(1);

  if (!associates.length) return null;

  return (
    <section id="coaches" className="bg-[#F0F5FF]">
      <div className="max-w-[1260px] mx-auto px-4">
        <div className="py-12 md:py-16">
          <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-8">
            <div>
              <p className="text-primary tracking-[0.19em] uppercase text-[14px] font-extrabold flex items-center gap-2 mb-4">
                <span className="inline-block w-6 h-[3px] bg-secondary rounded-full" />
                Guidance Throughout The Program
              </p>
              <h2 className="text-primary font-bold text-3xl md:text-5xl tracking-tight m-0">
                Associate Coaches and Delivery
              </h2>
            </div>
            <p className="text-[#565656] text-xl max-w-md m-0">
              A focused support team helps you move from live classes to
              confident product practice and a portfolio-ready final project.
            </p>
          </div>

          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
            {associates.map((coach) => (
              <CoachCard
                key={coach.coachId}
                name={coach.coachName}
                role={coach.coachRole}
                image={coach.coachImage}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CourseAssociateCoachesSection;
